import { Task, TaskEvidenceOutcome, TaskLinkType } from '@jms/model';
import { buildTaskEvidenceCard, EvidenceDateFormatter, TaskEvidenceCard } from '@workbuddy/entities/work.task/evidence.exception';

/** Outcomes whose details only the line's main task carries. */
export function needsItemEvidenceTask(outcome: TaskEvidenceOutcome | null | undefined): boolean {

  return outcome === TaskEvidenceOutcome.Exception || outcome === TaskEvidenceOutcome.Outstanding;
}

/** The line stores only the outcome; details come from its main item-task, never the SOR child tasks (E3). */
export function resolveItemEvidenceCard(outcome: TaskEvidenceOutcome | null | undefined, tasks: readonly Task[], formatDate: EvidenceDateFormatter): TaskEvidenceCard | null {

  return outcome ? buildTaskEvidenceCard(outcome, tasks.find(task => task.type === TaskLinkType.Item), formatDate) : null;
}
